export enum YearlyOrMonthly {
	MONTHLY = "MONTH",
	YEARLY = "YEAR",
}
